export const AvatarBackgroundColorConst = {
  COLOR_GREEN: 0,
  COLOR_ORANGE: 1,
  COLOR_PURPLE: 2,
  COLOR_RED: 3,
  COLOR_GREY: 4,
  COLOR_CYAN: 5,
  COLOR_BLUE: 6, // default colour
  COLOR_BRAND_ACCENT: 7,
  COLOR_SIZE: 8,
} as const;

export const getBackgroundColor = (
  learningProfileHashCode?: number,
): string => {
  const defaultBackgroundColor = '#1D559D';

  if (learningProfileHashCode === undefined) {
    return defaultBackgroundColor;
  }
  const colors = [
    '#1E771D',
    '#E05821',
    '#7C2EAA',
    '#B91E1E',
    '#5A6881',
    '#137D8B',
    defaultBackgroundColor,
    '#E60278',
  ];

  return colors[
    Math.abs(learningProfileHashCode) % AvatarBackgroundColorConst.COLOR_SIZE
  ];
};
